// G2PowerError.jsx
import "./IvError.css";
import React from "react";
import { useSelector } from "react-redux";
import { getIvDataIndex, getIvFieldValue } from "../../utils/ivErrorDataUtils";

// ✅ state 값 정의: 1=정지, 2=발전
const getStateLabel = (v) => {
  if (v === 1) return "정지";
  if (v === 2) return "발전";
  return "";
};

const getStateIcon = (v) => {
  if (v === 1) return "🔴"; // 정지
  if (v === 2) return "🟢"; // 발전
  return "⚪"; // unknown
};

const G2PowerError = ({ SelInverter }) => {
  const ivData = useSelector((state) => state.ivData || {});
  const dataIndex = getIvDataIndex(ivData, SelInverter);

  const getFieldValue = (key) => {
    return getIvFieldValue(ivData, key, SelInverter);
  };

  // ✅ Redux/백엔드 키가 "state"라면 그대로 사용
  const invState = getFieldValue("state"); // 1=정지, 2=발전

  if (dataIndex === -1) {
    return <div className="status-list-container">인버터를 선택하세요.</div>;
  }

  const icon = getStateIcon(invState);
  const label = getStateLabel(invState);

  return (
    <div className="status-list-container">
      <div className="status-list">
        <div className="status-item">
          <span className="status-value">
            State: {invState ?? 0} ({label})
          </span>
          <span className="status-icon">{icon}</span>
        </div>
      </div>
    </div>
  );
};

export default G2PowerError;
